import { render, staticRenderFns } from "./Visualizar.vue?vue&type=template&id=18e2759c&"
import script from "./Visualizar.vue?vue&type=script&lang=js&"
export * from "./Visualizar.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports